<template>
  <div class="flex">
    <div v-if="authenticated">
      <md-menu md-size="huge" md-align-trigger class="z-10">
        <md-button md-menu-trigger>
          <div class="flex">
            <notification-icon class="text-orange-academy-300"
            :class="$route.fullPath === dashboardPath+'/notifications' ?
            'text-'+textColor : 'hover:text-'+textColor" />
          </div>
          <span
          class="rounded-full w-4 h-4 md:w-5 md:h-5 flex justify-center items-center ml-3
            text-xs md:text-sm font-bold -top-1 absolute font-sans-serif mb-3"
          :class="isTeacher ? 'bg-beige-academy-300 text-white': 'bg-orange-academy-300 text-white'"
          v-if="notificationsToRead.length > 0">
          {{ notificationsToRead.length }}
        </span>
        </md-button>
        <md-menu-content class="bg-white z-10 w-auto">
            <notifications @open="$emit('open-notification', $event)"></notifications>
        </md-menu-content>
      </md-menu>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import Notifications from '../Notifications.vue';
import NotificationIcon from './NotificationIcon.vue';

export default {
  props: ['textColor'],

  components: {
    NotificationIcon,
    Notifications,
  },

  computed: {
    ...mapGetters({
      authenticated: 'auth/authenticated',
      user: 'auth/user',
      messagesToRead: 'auth/messagesToRead',
      notificationsToRead: 'auth/notificationsToRead',
      isTeacher: 'auth/isTeacher',
      isAdmin: 'auth/isAdmin',
      dashboardPath: 'auth/dashboardPath',
    }),

    containerColors() {
      if (this.user && this.isTeacher) {
        return 'bg-black text-purple-300 h-20 mb-5';
      }
      return 'text-orange-academy-300 h-24';
    },
  },
};
</script>
